import React from 'react';

const PopupMessage = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
    <div className="bg-white p-8 rounded shadow-lg w-96 h-64">
      <p className="text-lg">{message}</p>
      <button onClick={onClose} className="mt-4 bg-blue-500 text-white py-2 px-4 rounded">
        Close
      </button>
    </div>
  </div>
  );
};

export default PopupMessage;